<template>
  <el-dialog
    :visible.sync="addVisible"
    :close-on-click-modal="false"
    :before-close="clearAdd"
    width="700px"
  >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Product info" name="first">
        <el-form :model="companydata" ref="companydata" class="left" style="overflow: auto;height: 500px; text-align: left;" @submit.native.prevent>
      <el-form-item label="Product image:" :label-width="formLabelWidth">
        <img :src="companydata.image" alt width="50" height="50">
      </el-form-item>
      <el-form-item label="SKU:" :label-width="formLabelWidth">
        <span>{{companydata.sku}}</span>
      </el-form-item>
      <el-form-item label="Inventory SKU:" :label-width="formLabelWidth" prop="cff_sku">
        <el-input v-model="companydata.cff_sku" autocomplete="off" class="widy" disabled></el-input>
      </el-form-item>
      <el-form-item label="Product title:" :label-width="formLabelWidth" prop="desc_en">
        <el-input v-model="companydata.desc_en" autocomplete="off" class="widy" disabled></el-input>
      </el-form-item>
      <el-form-item label="Chinese title:" :label-width="formLabelWidth" prop="desc_cn">
        <el-input v-model="companydata.desc_cn" autocomplete="off" class="widy" disabled></el-input>
      
      </el-form-item>
      <el-form-item label="Product description:" :label-width="formLabelWidth" prop="material_en">
        <el-input v-model="companydata.material_en" autocomplete="off" class="widy" disabled></el-input>
      </el-form-item>
      <el-form-item label="Chinese description:" :label-width="formLabelWidth" prop="material_cn">
        <el-input v-model="companydata.material_cn" autocomplete="off" class="widy" disabled></el-input>
      
      </el-form-item>
      <el-form-item label="Price:" :label-width="formLabelWidth" prop="price">
        <el-input v-model="companydata.price " autocomplete="off" class="widy" disabled></el-input>
        <span>USD</span>
      </el-form-item>
      <el-form-item label="Declared value:" :label-width="formLabelWidth" prop="worth">
        <el-input v-model="companydata.worth" autocomplete="off" class="widy" disabled></el-input>
        <span>USD</span>
      </el-form-item>

      <el-form-item label="Length*width*height:" :label-width="formLabelWidth">
        <el-input v-model="companydata.length" autocomplete="off" style="width:73px"  disabled></el-input>
        <span>X</span>
        <el-input v-model="companydata.width" autocomplete="off" style="width:73px" disabled></el-input>
        <span>X</span>
        <el-input v-model="companydata.height" autocomplete="off" style="width:73px" disabled></el-input>
        <span>cm</span></br>
        <span class="fop">Actual measurement after storage</span>
      </el-form-item>
      <el-form-item label="Weight:" :label-width="formLabelWidth" prop="weight">
        <el-input v-model="companydata.weight" autocomplete="off" class="widy" disabled></el-input>
        <span>kg</span></br>
        <span class="fop">Actual measurement after storage</span>
      </el-form-item>
      <el-form-item label="HS Code:" :label-width="formLabelWidth" prop="hs_code">
        <el-input v-model="companydata.hs_code" autocomplete="off" class="widy" disabled></el-input>
        
      </el-form-item>
      <el-form-item label="Customs description:" :label-width="formLabelWidth" prop="remark">
        <el-input v-model="companydata.remark " autocomplete="off" class="widy" disabled></el-input>
      </el-form-item>
      <el-form-item label="Use:" :label-width="formLabelWidth" prop="purpose">
        <el-input v-model="companydata.purpose" autocomplete="off" class="widy" disabled></el-input>
      </el-form-item>
      <el-form-item label="Place of origin:" :label-width="formLabelWidth" prop="origin">
        <el-input v-model="companydata.origin" autocomplete="off" class="widy" disabled></el-input>
      </el-form-item>
      <el-form-item label="Whether to carry a battery:" :label-width="formLabelWidth">
        <el-radio v-model="companydata.withbattery" disabled  label="0">NO</el-radio>
        <el-radio v-model="companydata.withbattery" disabled  label="1">YES</el-radio>
      </el-form-item>
      <el-form-item label="Whether to carry liquid :" :label-width="formLabelWidth">
        <el-radio v-model="companydata.withliquid" disabled  label="0">NO</el-radio>
        <el-radio v-model="companydata.withliquid" disabled  label="1">YES</el-radio>
      </el-form-item>
    </el-form>
      </el-tab-pane>
      <el-tab-pane label="Check-in info" name="second">
        <el-row :gutter="20" style="text-align: left ;overflow: auto;height: 500px;">
          <el-col :span="24">
            <div>
              <el-input v-model="ANSinput" placeholder="ANS order number" style="width:200px"></el-input>
              <el-button
                style="background:#8989ba;color:#fff;outline: none"
                @click="ANSSearch"
              >Search</el-button>
            </div>
          </el-col>
          <el-col
            :span="24"
            style="margin-top: 10px;"
            v-for=" (intm,index) in ANSlist"
            :key="index"
          >
            <div>
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span class="lebh">ANS order number :{{intm.asnOrder}}</span>
                  <span
                    style="float: right; padding: 3px 0;color: #b0b0b0;font-size:12px"
                  >{{intm.created }}</span>
                </div>
                <div style="text-align: center" class="bg-purple1">
                  <!-- <el-table stripe style="width: 100%">
                    <el-table-column  label="ReservationQuantity" align="center"> {{intm.asnOrder}}</el-table-column>
                    <el-table-column  label="ActualIncomingQuantity" align="center"> {{intm.asnOrder}}</el-table-column>
                    <el-table-column  label="QualifiedQuantity" align="center"> {{intm.asnOrder}}</el-table-column>
                  </el-table>-->
                  <div style="background: #f3f5f8;color: #333;">
                    <el-col :span="8">ReservationQuantity</el-col>
                    <el-col :span="8">ActualIncomingQuantity</el-col>
                    <el-col :span="8">QualifiedQuantity</el-col>
                  </div>
                  <el-col :span="8">{{intm.estimate}}</el-col>
                  <el-col :span="8">{{intm.fact}}</el-col>
                  <el-col :span="8">{{intm.qualified}}</el-col>
                  <el-col :span="24" class="right">Other SKU :{{intm.other_sku_total}}</el-col>
                  <el-col :span="24" class="right">Inventory quantity :{{intm.other_sku_quantity }}</el-col>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="Shipment info" name="third">
        <div v-if="pment">  
        <el-row :gutter="20" style="text-align: left ;overflow: auto;height: 500px;">
          <el-col :span="24">
            <div>
              <el-input v-model="Orderinput" placeholder="Order number" style="width:200px"></el-input>
              <el-button
                style="background:#8989ba;color:#fff;outline: none"
                @click="OrderSearch"
              >Search</el-button>
            </div>
          </el-col>
          <el-col
            :span="24"
            style="margin-top: 10px;"
            v-for=" (intm,index) in Shipment"
            :key="index"
          >
            <div>
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span class="lebh">Order number :{{intm.orders_code}}</span>
                  <span
                    style="float: right; padding: 3px 0;color: #b0b0b0;font-size:12px"
                  >{{intm.add_time}}</span>
                </div>
                <div class="bg-purple1">
                  <el-col :span="10">Destination country :</el-col>
                  <el-col :span="14">{{intm.destination}}</el-col>
                  <el-col :span="10">Transportation channel:</el-col>
                  <el-col :span="14">{{intm.shipping_method}}</el-col>
                  <el-col :span="10">Order Status :</el-col>
                  <el-col :span="14">
                    {{intm.process_status}}
                    <span class="color" @click="toOrder(intm.ref_tracking_number)">{{intm.ref_tracking_number}}</span>
                  </el-col>
                  <el-col :span="10">Quantity :</el-col>
                  <el-col :span="14">{{intm. op_quantity}}</el-col>
                  <el-col :span="10">Other SKU :</el-col>
                  <el-col :span="14">{{intm.other_sku_quantity}}</el-col>
                  <!-- <el-col :span="24" class="right" style="color:#8989ba;height:40px">
                    Details
                    <i class="el-icon-d-arrow-right"></i>
                  </el-col> -->
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
        </div>
       <div v-else>
          <img src="../../../menu/img/nodata.png" alt="">
          <p>nodata</p>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
import { receivingitem, getordershipbyproduct } from "../../api/product";
export default {
  props: ["companydata", "rolesList", "visible"],
  data() {
    return {
      companyList: this.companydata,
      ANSinput: "",
      Orderinput: "",
      activeName: "first",
      addVisible: false,
      pment:false,
      ANSlist: [],
      Shipment: [],
       formLabelWidth: "180px",
    };
  },
  mounted() {
    // console.log(this.companyList)
    // this.$refs.multipleTable.toggleRowSelection(this.tableData[0],true);//默认选中
  },
  watch: {
    visible(val) {
      this.addVisible = val;
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab.index);
      if (tab.index == 1) {
        this.ANSlist=[]
        console.log(this.companydata);

        let productid = [];
        productid.push(this.companydata.productid);
        let param = {
          productid
        };
        receivingitem(param)
          .then(response => {
            console.log(response);
            //this.ANSlist=response.data
            if (response.data.ask == 1) {
              this.ANSlist = response.data.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else if (tab.index == 2) {
        this.Shipment=[];
        let productid = [];
        productid.push(this.companydata.productid);
        let param = {
          productid,
          orders_code: ""
        };
        getordershipbyproduct(param)
          .then(response => {
            console.log(response);
            //this.ANSlist=response.data
            if (response.data.ask == 1) {
              this.Shipment = response.data.data;
              this.pment=true
            } else {
              this.pment=false
            
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    clearAdd() {
      this.$emit("clearAdd");
      (this.activeName = "first"), (this.addVisible = false);
    },

    //搜索ANS单号
    ANSSearch() {
      console.log(this.ANSinput);

      let productid = [];
      productid.push(this.companydata.productid);
      let param = {
        productid,
        receiving_code: this.ANSinput
      };
      receivingitem(param)
        .then(response => {
          console.log(response);
          //this.ANSlist=response.data
          if (response.data.ask == 1) {
            this.ANSlist = response.data.data;
          } 
        })
        .catch(error => {
          console.log(error);
        });

      //console.log(this.companyList1);
    },
    toOrder(trackingnumber){
       window.open("https://www.sendfromchina.com/track/track/track/tracknumbers/"+trackingnumber)
    },
    OrderSearch() {
      let productid = [];
      productid.push(this.companydata.productid);
      let param = {
        productid,
        orders_code: this.Orderinput
      };
      getordershipbyproduct(param)
        .then(response => {
          console.log(response);
          //this.ANSlist=response.data
          if (response.data.ask == 1) {
            this.Shipment = response.data.data;
          } 
        })
        .catch(error => {
          console.log(error);
        });

      console.log(this.Orderinput);
    }
  }
};
</script>
<style scoped>
.bg-purple div {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.bg-purple {
  border-bottom: 1px solid #eee;
  height: 60px;
}
.bg-purple1 div {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.title2 {
  color: #aeaece;
  border-left: 3px solid #aeaece;
  margin: 10px;
  padding-left: 5px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
.color {
  color: #aeaece;
}
.right {
  text-align: right;
  font-size: 12px;
  color: #b0b0b0;
  padding: 5px;
}
.lebh {
  color: #8989ba;
  font-size: 16px;
  font-weight: blod;
}
.widy {
    width: 250px;
}
</style>






// WEBPACK FOOTER //
// src/components/views/storage/details/details.vue